<template>
    <div class="loading-spinner" v-bind:class="[getPosition == 'absolute' ? 'loading-spinner--absolute' : '', right ? 'loading-spinner--right' : '', left ? 'loading-spinner--left' : '']" :title="getMessage"></div>
</template>

<script>
    export default {
        name: 'PageLoading',
        props : {
            message : {
                type: String,
                default: ''
            },
            position: {
                type: String,
                default: 'relative'
            },
            right: {
                type: Boolean,
                default: false
            },
            left: {
                type: Boolean,
                default: false
            }
        },
        computed : {
            getPosition: function() {
                return this.position;
            },
            
            getMessage: function () {
                if (this.message === '') {
                    return this.$t('results_loading');
                }

                return this.message;
            }
        }
    };
</script>